import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Page } from '../models/page';
import { Country } from '../models/country';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor(private http: HttpClient) { }

  getCountries(): Promise<Page<Country>> {
    return this.http.get(environment.metApiName + '/countries?disablePagination=true&excludesStates=true').toPromise();
  }
}
